import { render, staticRenderFns } from "./ShopSwiper.vue?vue&type=template&id=61515845&scoped=true"
import script from "./ShopSwiper.vue?vue&type=script&lang=js"
export * from "./ShopSwiper.vue?vue&type=script&lang=js"
import style0 from "./ShopSwiper.vue?vue&type=style&index=0&id=61515845&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61515845",
  null
  
)

export default component.exports